import Config from '@/config';

export type CommsBackend = 'supabase' | 'pubnub';

export function getCommsBackend(): CommsBackend {
  return Config.COMMS_BACKEND === 'supabase' ? 'supabase' : 'pubnub';
}

export function isSupabaseCommsEnabled(): boolean {
  return getCommsBackend() === 'supabase';
}

export function getSupabaseConfig() {
  return {
    url: Config.SUPABASE_URL ?? '',
    publishableKey: Config.SUPABASE_PUBLISHABLE_KEY ?? '',
  };
}
